<template>
  <div>
    <ClickLimits
      v-model="clicksSpotHourly"
      class="mt-1"
      type="clicks_spot_hourly"
      @update:modelValue="update"
      @remove="remove"
    />
    <ClickLimits
      v-model="clicksDomainHourly"
      class="mt-1"
      type="clicks_domain_hourly"
      @update:modelValue="update"
      @remove="remove"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import {
  computedForCampaignLimits,
  defineUpdateCampaignLimits,
  defineRemoveCampaignLimits
} from '@/utils/limits'
import ClickLimits from './ClickLimits.vue'

export default defineComponent({
  name: 'TestCampaignLimits',
  components: {
    ClickLimits
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const clicksSpotHourly = computed(
      computedForCampaignLimits('clicks_spot_hourly', props)
    )
    const clicksDomainHourly = computed(
      computedForCampaignLimits('clicks_domain_hourly', props)
    )

    const update = defineUpdateCampaignLimits(props, context)
    const remove = defineRemoveCampaignLimits(props, context)

    return { clicksSpotHourly, clicksDomainHourly, update, remove }
  }
})
</script>
